export default "__VITE_ASSET__c0568c26__"